export function debugLog(...args) {
    if (typeof window !== "undefined" && window.DEBUG_SHAPER === true) {
        console.log(...args);
    }
}
